// Taux de rémunération CSPE/TICGN d'un client, en fraction (0.25 = 25 %).
//
// Priorité : 1. contrat fiscal SIGNÉ le plus récent (ce que le client a accepté),
//            2. fiche client (accounts.tax_remuneration_rate),
//            3. taux par défaut de l'écran.
// Incident 07/10/2026 : BAROUDI CHOKRI signé à 25 %, fiche vide → 35 % affichés par défaut.
// Copie conforme de backend/src/utils/tauxRemuneration.js (garder les deux alignées).

// Accepte 25, '25', 0.25 ; null / vide / 0 / illisible → null.
export function normaliserTaux(v) {
  if (v === null || v === undefined || v === '') return null;
  const n = Number(String(v).trim().replace(/\s/g, '').replace(',', '.'));
  if (!Number.isFinite(n) || n <= 0) return null;
  return n > 1 ? n / 100 : n;
}

/**
 * @param {{ tauxFiche: any, contrats?: Array<{type?:string,status?:string,signed_at?:string,created_at?:string,metadata?:object}>, defaut: number }} p
 * @returns {{ taux: number, source: 'contrat'|'fiche'|'defaut' }}
 */
export function resoudreTauxRemuneration({ tauxFiche, contrats = [], defaut }) {
  const signes = (contrats || [])
    .filter((d) => d && d.type === 'tax_contract' && d.status === 'signed'
      && normaliserTaux(d.metadata?.remunerationRate) !== null)
    .sort((a, b) => String(b.signed_at || b.created_at || '').localeCompare(String(a.signed_at || a.created_at || '')));
  if (signes.length) return { taux: normaliserTaux(signes[0].metadata.remunerationRate), source: 'contrat' };
  const fiche = normaliserTaux(tauxFiche);
  if (fiche !== null) return { taux: fiche, source: 'fiche' };
  return { taux: defaut, source: 'defaut' };
}
